<simple-card
  [cardTitle]="'Tools'"
  [titleFontSize]="'20px'"
  [enableShadow]="true"
  [showHeader]="true"
  [contentLayout]="'default'"
>
  <div class="tools-card-content">
    <a
      href="https://preclaruslabdata.ppdi.com/Preclarus/login"
      target="_blank"
      class="tools-card-tools"
    >
      <mat-icon svgIcon="preclarus-l" class="tools-img"></mat-icon>
      <div class="tools-content">
        <h6 class="tools-content-title">Preclarus Labs</h6>
        <p class="tools-content-body">Clinical laboratory data management</p>
      </div>
    </a>

    <a href="https://mysupply.patheon.com/login" target="_blank" class="tools-card-tools">
      <mat-icon svgIcon="my-supply" class="tools-img"></mat-icon>
      <div class="tools-content">
        <h6 class="tools-content-title">MySupply</h6>
        <p class="tools-content-body">End-to-end digital supply chain</p>
      </div>
    </a>

    <a
      href="https://preclarusdecisionconsole.ppdi.com/home"
      target="_blank"
      class="tools-card-tools"
    >
      <mat-icon svgIcon="preclarus-d" class="tools-img"></mat-icon>
      <div class="tools-content">
        <h6 class="tools-content-title">Preclarus Decision Console</h6>
        <p class="tools-content-body">Detailed clinical operations dashboards</p>
      </div>
    </a>
  </div>
</simple-card>
